module.exports = __webpack_public_path__ + "static/media/Banner_NOSQL.49546d20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/NoSQL/Banner_NOSQL.png
// module id = 67
// module chunks = 0